import React, { useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@mui/material';
import { MixpanelService } from 'utils/mixpanelService';

const CollisionDialog = ({ open, onClose, onDecision, collectionName }) => {
  useEffect(() => {
    if (open) MixpanelService.track("collision_modal_opened", { collection_name: collectionName });
  }, [open, collectionName]);

  const handleClose = () => {
    MixpanelService.track("collision_modal_closed", {});
    onClose();
  };
  const handleOverride = () => {
    MixpanelService.track("collision_modal_closed", { outcome: "override" });
    onDecision(false);
  };
  const handleCreateNew = () => {
    MixpanelService.track("collision_modal_closed", { outcome: "create_new" });
    onDecision(true);
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle sx={{ fontWeight: "500" }}>
        Already Exists
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ fontWeight: "500" }}>
          A collection named "{collectionName}" already exists. Would you like to override the existing collection or create a new one?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleOverride}
          sx={{ fontWeight: "500" }}
          variant="outlined"
          color='warning'
        >
          Override Existing
        </Button>
        <Button
          onClick={handleCreateNew}
          sx={{ fontWeight: "500" }}
          autoFocus
          color="primary"
          variant="contained"
        >
          Create New
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CollisionDialog;